// src/components/Dashboard/LowStockPartsPanel.js
import React from 'react';

const LowStockPartsPanel = ({ lowStockParts }) => {
	return (
		<div className="p-5 pt-0">
			<div className="overflow-x-auto">
				{lowStockParts?.length > 0 ? (
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-50">
						<tr>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Part Type
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Current Stock
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Threshold
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Deficit
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								On Order
							</th>
						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{lowStockParts.map((part, index) => (
							<tr key={index} className="hover:bg-gray-50">
								<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
									{part.product_sku}-{part.part_identifier}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{part.current_stock}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{part.threshold}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-red-500 font-medium">
									{part.deficit}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{part.on_order || 0}
								</td>
							</tr>
						))}
						</tbody>
					</table>
				) : (
					 <p className="text-gray-500 py-4">No low stock warnings at this time.</p>
				 )}
			</div>
		</div>
	);
};

export default LowStockPartsPanel;
